import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MaterialButton from "../../../../components/MaterialButton";
 
export default function CongratsPage() {
const navigate = useNavigate();
 const Backtolist=()=>{
   navigate('/course-assessment')
}
  return (
<Box
      maxWidth={600}
      margin="4rem auto"
      padding={4}
      boxShadow={3}
      borderRadius={2}
      bgcolor="background.paper"
      textAlign="center"
      fontFamily="'Roboto', 'Helvetica', 'Arial', sans-serif"
>
<Typography variant="h3" gutterBottom color="success.main" fontWeight={700}>
        🎉 Congratulations! 🎉
</Typography>
<Typography variant="h6" mb={4}>
        You have successfully completed the assessment.
</Typography>
 
      <MaterialButton
        variant="gradient"
        color="dark"
        size="large"
        onClick={Backtolist}
        sx={{ fontWeight: 600, px: 5, py: 1.5 }}
>
       Back to Assessment list
</MaterialButton>
</Box>
  );
}